<template>
	<v-menu absolute v-model="localValue" v-bind="$attrs" v-on="$listeners">
		<slot />
	</v-menu>
</template>

<script>
import VModelMixin from '@/mixins/VModelMixin';
/**
 * an absolute positioned menu component, receives in v-model the visibiliity state
 * expected to be pass props to v-menu component through $attrs={ positionX, positionY }
 */

export default {
	name: 'AppAbsoluteMenu',
	mixins: [VModelMixin],
};
</script>

<style scoped lang="scss">
.v-menu__content {
	contain: none !important; // this is to allow overflow from menu -- for dataItemInfoCard
}
</style>
